import React from "react";
import { Link } from "react-router-dom";
import { UilUserLocation } from "@iconscout/react-unicons";
import UiMosque from "../../../utils/icons/UiMosque";

export default function DeliveryOptions({
  deliveryOption,
  setDeliveryOption,
  donateWater,
}) {
  return (
    <div className="mt-5 p-6 rounded-2xl shadow-md font-poppins mb-6">
      <h2 className="text-lg font-semibold text-darkTextColor mb-4">
        Delivery Options
      </h2>
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 border border-cool-gray-200 rounded-md p-4 hover:border-primary transition-colors">
          <Link
            to="/user/addressbook"
            state={{ PageTitle: "Address" }}
            className="flex items-center gap-2"
          >
            <UilUserLocation className="w-5 h-5 text-orange-600" />
            Create / Update Address(s)
          </Link>
        </div>

        <label className="flex-1 flex items-center gap-3 border border-cool-gray-200 rounded-md p-4 hover:border-primary cursor-pointer transition-colors">
          <input
            type="radio"
            name="deliveryOption"
            value="delivery"
            checked={deliveryOption === "delivery"}
            onChange={(e) => setDeliveryOption(e.target.value)}
          />
          <span>Deliver to my address</span>
        </label>

        <label className="flex-1 flex items-center gap-3 border border-cool-gray-200 rounded-md p-4 hover:border-primary cursor-pointer transition-colors">
          <input
            type="radio"
            name="deliveryOption"
            value="mosque"
            checked={deliveryOption === "mosque"}
            onChange={(e) => setDeliveryOption(e.target.value)}
          />
          <span className="relative text-primary font-poppins font-semibold">
            Direct Mosque Delivery
            {deliveryOption !== "mosque" && (
              <>
                <span className="absolute -top-2 -right-3 w-3 h-3 bg-red-500 rounded-full animate-ping"></span>
                <span className="absolute -top-2 -right-3 w-3 h-3 bg-red-500 rounded-full"></span>
              </>
            )}
          </span>
        </label>
      </div>
      {donateWater && (
        <div className="mt-2 flex items-center rounded-md p-2 bg-yellow-liner text-yellow-800">
          <UiMosque
            className="w-5 h-5 mr-3 flex-shrink-0"
            fillColor="#0A32A0"
          />
          <span className="text-sm text-C12 ml-2">
            Your order will be donated to one of your nearest mosques and you
            will be notified. Alternatively, you can click on{" "}
            <strong>Mosque Orders</strong> in the left menu.
          </span>
        </div>
      )}
    </div>
  );
}
